import React, { useEffect, useState, useRef, useCallback } from "react";
import { chatService } from "./../../services/chat.service";
import { Searches } from "./searches";
import { TtlsChats } from "./ttlsChats";
import { AvatarChats } from "./avatarChats";
import { FaCommentDots, FaTimesCircle } from "react-icons/fa";
import { BsChevronLeft } from "react-icons/bs";

export function ListContact({ showChat }) {
  const [contacts, setContacts] = useState([]);
  const [blockedContacts, setBlockedContacts] = useState([]);
  const [contactsSearch, setContactsSearch] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const limit = 20; // Número de contactos a cargar por solicitud

  // Cargar contactos con paginación
  const loadContacts = useCallback(() => {
    if (isLoading || !hasMore) return;

    setIsLoading(true);
    chatService.getContactsOpt(offset, limit).then((response) => {
      if (response.contacts.length > 0) {
        setContacts((prevContacts) => [...prevContacts, ...response.contacts]);
        setContactsSearch((prevContacts) => [...prevContacts, ...response.contacts]);
      }

      setHasMore(response.hasMore);
      setOffset((prevOffset) => prevOffset + limit);
      setIsLoading(false);
    });
  }, [offset, hasMore, isLoading]);

  useEffect(() => {
    loadContacts();
  }, []);

  // Detectar scroll al final de la lista
  const observer = useRef();
  const lastContactRef = useCallback(
    (node) => {
      if (isLoading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          loadContacts();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoading, hasMore]
  );

  const handleSearch = (text) => {
    if (text) {
      text = text.toUpperCase();
      let filteredContacts = contacts.filter((item) =>
        item.name.toUpperCase().includes(text)
      );

      setContactsSearch(filteredContacts.length > 0 ? filteredContacts : []);
    } else {
      setContactsSearch(contacts);
    }
  };

  const handleOpenChat = (user) => {
    const chat = {
      contactId: user.userId,
      name: user.name,
      image: user.urlImage,
      identityFlagName: user.flag,
      readOnly: false,
    };
    showChat(chat);
  };

  const [openBlocked, setOpenBlocked] = useState("");
  const handleOpenBlocked = () => {
    setOpenBlocked(openBlocked === "" ? "open" : "");
  };

  return (
    <div className="sections-chat active contacts-container list-users p-3">
      <div className="list-users-options">
        <TtlsChats title="Contactos" />
        <button className="btn-new-group" onClick={handleOpenBlocked}>
          <FaTimesCircle />
          <span>Bloqueados</span>
        </button>
      </div>
      <Searches placeHolder="Buscar contacto" handleSearch={handleSearch} />

      <div className="contacts-container-content">
        {contactsSearch.map((contact, index) => {
          let isLastContact = index === contactsSearch.length - 1;

          return (
            <div
              key={contact.userId}
              ref={isLastContact ? lastContactRef : null}
              className="item"
            >
              <AvatarChats img={contact.urlImage} flagClass={contact.flag} />
              <div className="item-chat">
                <p className="name">{contact.name}</p>
                <div className="options">
                  <span className="opt_chat" onClick={() => handleOpenChat(contact)}>
                    <FaCommentDots />
                  </span>
                </div>
              </div>
            </div>
          );
        })}
        {isLoading && <p>Cargando más contactos...</p>}
      </div>

      <div className={`list-user-blocked ${openBlocked}`}>
        <div className="d-flex-between" style={{ paddingBottom: "1rem" }}>
          <button type="button" className="button-back" onClick={handleOpenBlocked}>
            <BsChevronLeft />
          </button>
          <h6>Usuarios bloqueados</h6>
        </div>
        {blockedContacts.map((contact) => (
          <div className="item" key={contact.userId}>
            <AvatarChats img={contact.urlImage} flagClass={contact.flag} />
            <div className="item-chat">
              <p className="name">{contact.name}</p>
              <div className="options">
                <span onClick={() => handleOpenChat(contact)}>
                  <FaCommentDots />
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

